import { OidcMetadata } from "oidc-client";
import { UserManagerSettings } from "oidc-client-ts";
import { IApplicationSettings, GetApplicationSetting } from "../assets/configuration";
import { ApplicationHelper } from "../assets/utils/helpers";

const settings: IApplicationSettings = GetApplicationSetting;

export const identityConfig: UserManagerSettings = {
    authority: settings.authSettings.authUrl,
    client_id: settings.authSettings.clientId,
    client_secret: settings.authSettings.clientSecret,
    response_type: settings.authSettings.responseType,
    scope: settings.authSettings.scope,
    checkSessionIntervalInSeconds: settings.authSettings.checkSessionIntervalInSeconds,

    redirect_uri: ApplicationHelper.BaseUrl() + "/signin-oidc",
    silent_redirect_uri: ApplicationHelper.BaseUrl() + "/silentrenew",
    post_logout_redirect_uri: ApplicationHelper.BaseUrl(),
    automaticSilentRenew: true,
    loadUserInfo: true,
    disablePKCE: false,
    
};

export const metaDataConfig: OidcMetadata = {
    issuer: settings.authSettings.authUrl,
    jwks_uri: settings.authSettings.authUrl + "/.well-known/openid-configuration/jwks",
    authorization_endpoint: settings.authSettings.authUrl + "/connect/authorize",
    token_endpoint: settings.authSettings.authUrl + "/connect/token",
    userinfo_endpoint: settings.authSettings.authUrl + "/connect/userinfo",
    end_session_endpoint: settings.authSettings.authUrl + "/connect/logout",
    check_session_iframe: settings.authSettings.authUrl + "/connect/checksession",
    revocation_endpoint: settings.authSettings.authUrl + "/connect/revocation",
    introspection_endpoint: settings.authSettings.authUrl + "/connect/introspect",
    token_endpoint_auth_methods_supported: [],
    token_endpoint_auth_signing_alg_values_supported: [],
    registration_endpoint: "",
    scopes_supported: [],
    response_types_supported: [],
    acr_values_supported: [],
    subject_types_supported: [],
    userinfo_signing_alg_values_supported: [],
    userinfo_encryption_alg_values_supported: [],
    userinfo_encryption_enc_values_supported: [],
    id_token_signing_alg_values_supported: [],
    id_token_encryption_alg_values_supported: [],
    id_token_encryption_enc_values_supported: [],
    request_object_signing_alg_values_supported: [],
    display_values_supported: [],
    claim_types_supported: [],
    claims_supported: [],
    claims_parameter_supported: false,
    service_documentation: "",
    ui_locales_supported: [],
    frontchannel_logout_supported: false,
    frontchannel_logout_session_supported: false,
    backchannel_logout_supported: false,
    backchannel_logout_session_supported: false,
    grant_types_supported: [],
    response_modes_supported: [],
    code_challenge_methods_supported: []
};
